import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { LfaContextAPIShape } from '../../../Context/LfaContext';
import InputText from '../../FormFields/Text';
import Button from '../../Common/Button';
import FormContextProvider, { FormContext } from '../../../Context/FormContext';
import DFFCloneService from '../../../Services/DFFCloneService';
import ConfigService from "../../../Services/api/Config";
import Icon from "../../Common/Icon";
import {ReactComponent as InfoIcon} from "../../../../img/icon-info.svg";
import {ReactComponent as CloseIcon} from "../../../../img/dialog-close.svg";

class ModalCloneSection extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      label: this.props.label || '',
      errors: {},
    };
  }

  onPressClose = (event) => this.props.onClose(event);

  onPressSave = async (event) => {
    DFFCloneService.cloneSection(this.props.api, this.props.configuration, this.state.label);
    this.props.onClose(event);
  };

  onChangeLabel = (label) => {
    this.setState({
      label,
    });
  };

  onChangeError = (key, error) => {
    const { errors } = this.state;
    errors[key] = error;
    this.setState({
      errors,
    });
  };

  render() {
    const { api, configuration } = this.props;
    const {label, errors} = this.state;
    return (
      <FormContextProvider>
        <FormContext.Consumer>
          { context => (
            <Modal
              isOpen
              onRequestClose={ this.onPressClose }
              contentLabel='Clone section'
              className='Modal_Content'
              overlayClassName='Modal_Overlay'
            >
              <div className='Modal_Content_Container Center'>
                <h2>CLONE SECTION FORM</h2>
                <div className='Warning_Container' style={ { color: ConfigService.getColor('warningColor') } }>
                  <Icon className='Icon-Warning' width='16' height='16' color='warningColor'>
                    <InfoIcon alt='icon-info'/>
                  </Icon>
                  Are you sure you want to clone this section?
                </div>
                { configuration.lockLabel &&
                  <div className='Align_Left Section_Label'>
                    New Section Label:
                    <span>{ label }</span>
                  </div>
                  ||
                  <InputText
                    placeholder='Label'
                    onChange={ this.onChangeLabel }
                    required
                    validators={ [api.checkLabelExist] }
                    value={ label }
                    error={ errors['label'] }
                    onError={ (error) => this.onChangeError('label', error) }
                  />
                }
                <div className='Modal_Content_Actions Center'>
                  <Button className='Inline'
                    onClick={ (event) => context.submit(() => this.onPressSave(event), errors)  }
                  >
                    Yes
                  </Button>
                  <Button className='Button_Cancel Inline'
                    onClick={ (event) => context.cancel(() => this.onPressClose(event)) }
                  >
                    Cancel
                  </Button>
                </div>
                <div className='Modal_Content_Close' onClick={ (event) => context.cancel(() => this.onPressClose(event)) }>
                  <Icon className='Icon-Close' width='12' height='12' color='secondaryColor'>
                    <CloseIcon alt='icon-close'/>
                  </Icon>
                </div>
              </div>
            </Modal>
          ) }
        </FormContext.Consumer>
      </FormContextProvider>
    );
  }
}

ModalCloneSection.propTypes = {
  configuration: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  api: LfaContextAPIShape,
  onClose: PropTypes.func.isRequired,
};

export default ModalCloneSection;
